/**
 * All the activities we do in the store. Comments indicate the slice of
 * the state tree *most* of the time. But it is possible for one slice
 * to engage in any 'activity' it wants. The Journal is an example.
 *
 * Goes without saying that if you are making a new action in the store,
 * it goes here <3
 */
enum ACTIVITIES {
  // Initial state
  idling = "IDLING_AWAY_YO_MAKE_SOMETHING_HAPPEN_LOL",

  // Authentication
  authenticating = "AUTHENTICATE_USER",

  // User
  getUser = "GET_USER",
  updateUser = "UPDATE_USER",

  // Crops
  getCrops = "GET_CROPS",

  // Operation List
  getListOfOperations = "GET_LIST_OF_OPERATIONS",
  updateList = "UPDATING_LIST_OF_OPERATIONS",
  addOperation = "ADD_OPERATION",
  updateOperation = "UPDATE_OPERATION",
  deleteOperation = "DELETE_OPERATION",

  // Current Operation
  addFarm = "ADD_FARM",
  removeFarm = "REMOVE_FARM",
  renameFarm = "RENAME_FARM",
  deleteCurrentOperation = "DELETE_CURRENT_OPERATION",
  deleteMember = "DELETE_MEMBER",
  inviteMember = "INVITE_MEMBER",
  inviteMembers = "INVITE_MEMBERS",
  setCurrentOperation = "SET_CURRENT_OPERATION",
  unInviteMember = "UN_INVITE_MEMBER",
  updateCurrentOperation = "UPDATE_CURRENT_OPERATION",
  updateMemberPermissions = "UPDATE_MEMBER_PERMISSIONS",
  enrollFields = "ENROLL_FIELDS",
  addField = "ADD_FIELD",
  removeField = "REMOVE_FIELD",
  removeCortevaMembers = "REMOVE_CORTEVA_MEMBERS",

  // Refetch Data
  refetchFields = "REFETCH_FIELDS",
  refetchMembers = "REFETCH_MEMBERS",
  refetchFarms = "REFETCH_FARMS",
}

export default ACTIVITIES;
